import "@/lib/polyfills";
import "@/styles/main.sass";
import loadConfig from "@/loadConfig";

loadConfig()
  .then(() => import("./"))
  .then(({ createApp }) => createApp())
  .catch(e => import("@/views/PageError").then(page => page.default(e)));
